import { SwoopDefaultIntegration } from './swoop-default.integration';
import { SwoopIntegrationTypeEnum } from '../../dto/recs.dto';
import { AdSet } from '../../entities/ad-set';
import { BrowserObjectModel } from '../browser-object-model';
import { UserContext } from '../context/user.context';
import { Injectable } from '../dependency-injection/decorators';

@Injectable()
export class SwoopPassthroughIntegration extends SwoopDefaultIntegration {
  public constructor (
    protected override readonly browserObjectModel: BrowserObjectModel,
    protected override readonly userContext: UserContext,
  ) {
    super(browserObjectModel, userContext);
  }

  public override supports (adSet: AdSet): boolean {
    return adSet.getSettings().getSwoopIntegrationType() === SwoopIntegrationTypeEnum.PASSTHROUGH;
  }
}
